import { useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';

import { getListGroupsAdministrationQueryKey, useUpdateGroupsAdministration } from '@/modules/api/codegen';
import { actions as messagesActions } from '@/modules/messages';

export const useUpdateGroups = () => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    const updateGroupsMutation = useUpdateGroupsAdministration({
        mutation: {
            onSuccess: async (_, { data: { groupIds } }) => {
                await queryClient.invalidateQueries({ queryKey: getListGroupsAdministrationQueryKey() });

                dispatch(
                    messagesActions.displaySuccessMessage({
                        message: { id: 'user-administration.table.actions.success', values: { numberOfRecords: groupIds?.length } },
                        options: { duration: 5 },
                    }),
                );
            },
            onError: () =>
                dispatch(
                    messagesActions.displayErrorMessage({
                        message: { id: 'user-administration.table.actions.error' },
                        options: { duration: 5 },
                    }),
                ),
        },
    });

    return updateGroupsMutation;
};
